module.exports = __webpack_public_path__ + "img/user-avatar-placeholder.714c85cd.svg";